export const cacheKey = "/engagement/location_set_triggers" as const;
